import { Boxscore, Gumbo } from "../lib/types/statsApi";

const STATS_BASE_URL = "https://statsapi.mlb.com";

export default class StatsApi {
  static fetchGame(gamePk: number, timecode?: string): Promise<Gumbo> {
    let timecodeSuffix = "";
    if (timecode) {
      timecodeSuffix = `?timecode=${timecode}`;
    }
    return fetch(
      `${STATS_BASE_URL}/api/v1.1/game/${gamePk}/feed/live${timecodeSuffix}`
    )
      .then((r) => {
        if (r.status !== 200) {
          return Promise.reject(
            `Failed to fetch game from Stats API. Status code: ${r.status}`
          );
        }
        return r.json();
      })
      .catch((e) => console.error(e));
  }

  static fetchDiffPatch(
    gamePk: number,
    prevTimecode: string,
    currentTimecode: string
  ): Promise<Gumbo> {
    return fetch(
      `${STATS_BASE_URL}/api/v1.1/game/${gamePk}/feed/live/diffPatch?startTimecode=${prevTimecode}&endTimecode=${currentTimecode}`
    )
      .then((r) => {
        if (r.status !== 200) {
          return Promise.reject(
            `Failed to fetch game from Stats API. Status code: ${r.status}`
          );
        }
        return r.json();
      })
      .catch((e) => console.error(e));
  }

  static fetchBoxscore(gamePk: number): Promise<Boxscore> {
    return fetch(
      `${STATS_BASE_URL}/api/v1/game/${gamePk}/boxscore?hydrate=person`
    )
      .then((r) => {
        if (r.status !== 200) {
          return Promise.reject(
            `Failed to fetch game from Stats API. Status code: ${r.status}`
          );
        }
        return r.json();
      })
      .catch((e) => console.error(e));
  }
}
